<template>
  <BTab @click="handleTabChange">
    <template #title>
      <div class="mb-0 d-flex align-items-center">
        <span>
          {{ __('Estágios do Funil') }}
        </span>
        <span class="ml-2" v-if="loading"><i class="fa fa-circle-o-notch fa-spin" /></span>
        <span
          class="ml-2 rounded-circle bg-custom-purple counter-size text-white fs-7 d-flex align-items-center justify-content-center"
          id="pipeline-counter" v-else>
          {{ pipelinesCounter }}
        </span>
      </div>
    </template>
    <div class="d-flex flex-row align-items-center">
      <p class="form-text my-0">
        {{ __('Aqui você pode criar e alterar o nome dos seus pipelines e estágios do funil de vendas.') }}.
      </p>
      <button class="btn btn-primary ml-auto" @click.prevent="createPipeline()">
        {{ __('Adicionar pipeline') }}
      </button>
    </div>
    <div class="row px-3">
      <div class="col-12">
        <span class="mt-4" v-if="loading"><i class="fa fa-circle-o-notch fa-spin" /></span>
        <Draggable class="pipelines settings-group row" tag="div" v-model="pipelines" :group="'pipelines'"
          @start="startDrag" @end="endDrag" v-else>
          <div class="col-12 mt-3 gray-border-table-wrapper box-shadow-custom px-0" :class="{'mt-4-5': indexPipeline > 0}" v-for="(pipeline, indexPipeline) in pipelines"
            :key="indexPipeline">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th class="d-flex align-items-center purple-title-wrapper py-2-5 pr-3 pl-4-5">
                    <!-- <div class="purple-title-wrapper"> -->
                    <span class="mr-3 break-text text-transform-none lh-24">{{ pipeline.name }}</span>
                    <a class="ml-auto" href="#" v-b-tooltip.left="__('Editar pipeline')"
                      @click.prevent="editPipeline(pipeline)">
                      <IconPencilEraserWithoutMiddleLines :size="16" />
                    </a><a class="ml-3" href="#" v-b-tooltip.left="__('Adicionar estágio')"
                      @click.prevent="create(pipeline.id)">
                      <IconThinSumSign :size="12" />
                    </a><a class="ml-3" href="#" v-b-tooltip.left="__('Excluir pipeline')"
                      @click.prevent="destroyPipeline(pipeline)" v-if="can.delete && indexPipeline > 0">
                      <IconThinTrashCan :size="16" />
                    </a>
                    <!-- </div> -->
                  </th>
                </tr>
              </thead>
              <Draggable tag="tbody" v-model="pipeline.stages" :group="'stage'" @start="startDrag" @end="endDrag">
                <tr class="draggable-row"
                  :class="[index === pipeline.stages.length - 1 ? 'last-stage d-flex align-items-center' : '']"
                  v-for="(stage, index) in pipeline.stages" :key="index" :change="endDrag"
                  @mouseover="changeColor(true, index)" @mouseleave="changeColor(false, index)">
                  <span class="draggable-icon" v-if="isColor && trHoverIndex == index">
                    <svg width="14" height="15" viewBox="0 0 14 15" fill="#000000" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M10.5 1.375C10.7321 1.375 10.9546 1.46719 11.1187 1.63128C11.2828 1.79538 11.375 2.01794 11.375 2.25L11.375 4C11.375 4.23206 11.2828 4.45462 11.1187 4.61872C10.9546 4.78281 10.7321 4.875 10.5 4.875L8.75 4.875C8.51794 4.875 8.29538 4.78281 8.13128 4.61872C7.96719 4.45462 7.875 4.23206 7.875 4L7.875 2.25C7.875 2.01794 7.96719 1.79538 8.13128 1.63128C8.29538 1.46719 8.51794 1.375 8.75 1.375L10.5 1.375ZM10.5 5.75C10.7321 5.75 10.9546 5.84219 11.1187 6.00628C11.2828 6.17038 11.375 6.39294 11.375 6.625L11.375 8.375C11.375 8.60706 11.2828 8.82962 11.1187 8.99372C10.9546 9.15781 10.7321 9.25 10.5 9.25L8.75 9.25C8.51794 9.25 8.29538 9.15781 8.13128 8.99372C7.96719 8.82962 7.875 8.60706 7.875 8.375L7.875 6.625C7.875 6.39294 7.96719 6.17038 8.13128 6.00628C8.29538 5.84219 8.51794 5.75 8.75 5.75L10.5 5.75ZM10.5 10.125C10.7321 10.125 10.9546 10.2172 11.1187 10.3813C11.2828 10.5454 11.375 10.7679 11.375 11L11.375 12.75C11.375 12.9821 11.2828 13.2046 11.1187 13.3687C10.9546 13.5328 10.7321 13.625 10.5 13.625L8.75 13.625C8.51793 13.625 8.29538 13.5328 8.13128 13.3687C7.96719 13.2046 7.875 12.9821 7.875 12.75L7.875 11C7.875 10.7679 7.96719 10.5454 8.13128 10.3813C8.29538 10.2172 8.51794 10.125 8.75 10.125L10.5 10.125ZM6.125 1.375C6.35706 1.375 6.57962 1.46719 6.74372 1.63128C6.90781 1.79538 7 2.01794 7 2.25L7 4C7 4.23206 6.90781 4.45462 6.74372 4.61872C6.57962 4.78281 6.35706 4.875 6.125 4.875L4.375 4.875C4.14294 4.875 3.92038 4.78281 3.75628 4.61872C3.59219 4.45462 3.5 4.23206 3.5 4L3.5 2.25C3.5 2.01794 3.59219 1.79538 3.75628 1.63128C3.92038 1.46719 4.14294 1.375 4.375 1.375L6.125 1.375ZM6.125 5.75C6.35706 5.75 6.57962 5.84219 6.74372 6.00628C6.90781 6.17038 7 6.39294 7 6.625L7 8.375C7 8.60706 6.90781 8.82962 6.74372 8.99372C6.57962 9.15781 6.35706 9.25 6.125 9.25L4.375 9.25C4.14294 9.25 3.92038 9.15781 3.75628 8.99372C3.59219 8.82962 3.5 8.60706 3.5 8.375L3.5 6.625C3.5 6.39294 3.59219 6.17038 3.75628 6.00628C3.92038 5.84219 4.14294 5.75 4.375 5.75L6.125 5.75ZM6.125 10.125C6.35706 10.125 6.57962 10.2172 6.74372 10.3813C6.90781 10.5454 7 10.7679 7 11L7 12.75C7 12.9821 6.90781 13.2046 6.74372 13.3687C6.57962 13.5328 6.35706 13.625 6.125 13.625L4.375 13.625C4.14294 13.625 3.92038 13.5328 3.75628 13.3687C3.59219 13.2046 3.5 12.9821 3.5 12.75L3.5 11C3.5 10.7679 3.59219 10.5454 3.75628 10.3813C3.92038 10.2172 4.14294 10.125 4.375 10.125L6.125 10.125Z"
                        fill="#ADB1B7" fill-opacity="0.5" />
                    </svg>
                  </span>
                  <td class="d-flex align-items-center lh-21 custom-td-padding">
                    <span class="text-break mr-3">{{ stage.name }}<span class="ml-1" v-if="stage.automation_id">-<b
                          class="ml-1">Campanha:</b><span class="ml-1">{{ stage.automation ? stage.automation.name :
                            ''
                          }}</span></span></span><a class="ml-auto" href="#" v-b-tooltip.left="__('Editar estágio')"
                      @click.prevent="edit(stage)">
                      <IconPencilEraserWithoutMiddleLines :size="16" />
                    </a><a class="ml-3" href="#" v-b-tooltip.left="__('Excluir estágio')"
                      @click.prevent="destroy(stage)" v-if="can.delete && index > 2">
                      <IconThinTrashCan :size="16" />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td class="d-flex align-items-center lh-21 custom-td-padding" v-if="pipeline.stages.length == 0">
                    {{ __('Nenhum estágio cadastrado! Arraste ou crie um novo estágio') }}.
                  </td>
                </tr>
              </Draggable>
            </table>
          </div>
        </Draggable>
      </div>
    </div>
    <BModal id="custom-stage-modal" ref="custom-stage-modal" modal-class="modal-width-380" hide-footer="hide-footer">
      <template slot="modal-header">
        <div class="modal-title" v-if="status.editing">
          {{ __('Editar Estágio') }}
        </div>
        <div class="modal-title" v-else>
          {{ __('Criar Estágio') }}
        </div>
        <button class="close" type="button" data-dismiss="modal" aria-label="Close" @click="closeModal()">
          <span aria-hidden="true"><img class="mb-5px" src="/build/icons/close@white.svg" width="14" height="13"></span>
        </button>
      </template>
      <template slot="default">
        <form class="form" role="form" @submit.prevent="save">
          <div class="form-group" :class="{ 'has-error': createStageForm.errors.has('name') }">
            <label class="fw-medium">{{ __('Estágio') }}</label>
            <input class="form-control radius-8 px-3 select-border" required="required" type="text" name="name"
              v-model="createStageForm.name" ref="stage-name" :placeholder="__('Nome do estágio')"><span class="form-text"
              v-show="createStageForm.errors.has('name')">{{
                createStageForm.errors.get('name') }}</span>
          </div>
          <div class="form-group" :class="{ 'has-error': createStageForm.errors.has('automation_id') }">
            <label class="fw-medium">{{ __('Aplicar campanha') }}</label>
            <select class="form-control radius-8 mb-3 select-border" v-model="createStageForm.automation_id">
              <option :value="null" disabled>
                {{ __('Selecione') }}
              </option>
              <option :value="id" v-for="(automation, id) in automations" :key="id">
                {{ automation }}
              </option>
            </select>
            <p class="form-text mt-0">
              {{ __('Sempre que um lead/negócio for movido para este estágio, essa campanha será aplicada') }}.
            </p>
            <p class="form-text mb-4-5">
              {{ __('Caso o lead já tenha entrado na campanha, ela não será aplicada novamente') }}.
            </p><span class="form-text" v-show="createStageForm.errors.has('automation_id')">{{
              createStageForm.errors.get('automation_id') }}</span>
          </div>
          <div class="modal-footer bg-salesflow-bg-body default-modal-footer">
            <button class="btn btn-primary mx-0" type="submit" :disabled="status.saving">
              <span v-if="status.saving">{{ __('Salvando') }}...</span><span v-else>{{ __('Salvar') }}</span>
            </button>
            <button class="btn pb-0 mx-0" type="button" :disabled="status.saving" @click.prevent="cancel()">
              <u class="btn-cancel">{{ __('Cancelar') }}</u>
            </button>
          </div>
        </form>
      </template>
    </BModal>
    <BModal id="custom-pipeline-modal" ref="custom-pipeline-modal" modal-class="modal-width-380"
      hide-footer="hide-footer">
      <template slot="modal-header">
        <div class="modal-title" v-if="pipelineStatus.editing">
          {{ __('Editar Pipeline') }}
        </div>
        <div class="modal-title" v-else>
          {{ __('Criar Pipeline') }}
        </div>
        <button class="close" type="button" data-dismiss="modal" aria-label="Close"
          @click="closeModal('custom-pipeline-modal')">
          <span aria-hidden="true"><img class="mb-5px" src="/build/icons/close@white.svg" width="14" height="13"></span>
        </button>
      </template>
      <template slot="default">
        <form class="form" role="form" @submit.prevent="savePipeline">
          <div class="form-group" :class="{ 'has-error': createPipelineForm.errors.has('name') }">
            <label class="fw-medium">Pipeline</label>
            <input class="form-control radius-8 px-3 select-border" required="required" type="text" name="name"
              v-model="createPipelineForm.name" ref="pipeline-name" :placeholder="__('Nome do pipeline')"><span class="form-text"
              v-show="createPipelineForm.errors.has('name')">{{
                createPipelineForm.errors.get('name') }}</span>
          </div>
          <div class="d-flex flex-column modal-footer bg-salesflow-bg-body default-modal-footer p-0 mt-4-5">
            <button class="btn btn-primary mx-0" type="submit" :disabled="pipelineStatus.saving">
              <span v-if="pipelineStatus.saving">{{ __('Salvando') }}...</span><span v-else>{{ __('Salvar') }}</span>
            </button>
            <button class="btn mx-0 pb-0" type="button" :disabled="pipelineStatus.saving"
              @click.prevent="cancelPipeline()">
              <u class="btn-cancel">{{ __('Cancelar') }}</u>
            </button>
          </div>
        </form>
      </template>
    </BModal>
  </BTab>
</template>

<script>
import { BModal, VBTooltip, BTab } from 'bootstrap-vue';
import { Confirm } from '../../../../services/Confirm';

function addStageForm() {
  return {
    name: '',
    stage_id: '',
    automation_id: null,
    pipeline_id: '',
  };
}

function addPipelineForm() {
  return {
    name: '',
  };
}

export default {
  components: {
    BModal,
    BTab,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  props: ['can', 'isActive'],

  mounted() {
    this.getAutomations();

    if (this.pipelines.length === 0) {
      this.getPipelines();
    }

    const self = this;

    this.$root.$on('bv::modal::show', (event, modalId) => {
      if (modalId == 'custom-stage-modal') {
        setTimeout(() => self.$refs['stage-name'].focus());
      }

      if (modalId == 'custom-pipeline-modal') {
        setTimeout(() => self.$refs['pipeline-name'].focus());
      }
    });

    this.$root.$on('bv::modal::hide', (event, modalId) => {
      if (modalId == 'custom-stage-modal' || modalId == 'custom-pipeline-modal') {
        this.pipelineStatus.editing = false;
        this.pipelineStatus.saving = false;
      }
    });
  },

  data() {
    return {
      pipeline: '',
      pipelinesCounter: 0,
      isColor: false,
      trHoverIndex: null,
      pipelines: [],
      automations: [],
      status: {
        editing: false,
        saving: false,
        moving: false,
      },
      pipelineStatus: {
        editing: false,
        saving: false,
        moving: false,
      },
      loading: true,
      dragging: false,
      moving: false,
      createPipelineForm: new BulldeskForm(addPipelineForm()),
      deletePipelineForm: new BulldeskForm(),
      createStageForm: new BulldeskForm(addStageForm()),
      deleteStageForm: new BulldeskForm(),
      orderPipelineForm: new BulldeskForm(),
    };
  },

  methods: {
    handleTabChange() {
      console.log('handleTabChange', 0);
      Bus.$emit('tab-changed', 0);
    },

    changeColor(isOver, index) {
      if (isOver) {
        this.isColor = true;
        this.trHoverIndex = index;
      } else {
        this.isColor = false;
        this.trHoverIndex = null;
      }
    },

    getPipelines() {
      this.loading = true;

      this.$http.get('/pipeline')
        .then((response) => {
          this.pipelinesCounter = response.data.counter;
          this.pipelines = response.data.pipelines.map((pipeline) => {
            pipeline.show = false;

            return pipeline;
          });

          this.loading = false;
        });
    },

    createPipeline() {
      this.pipelineStatus.editing = false;

      this.createPipelineForm = new BulldeskForm(addPipelineForm());
      this.$refs['custom-pipeline-modal'].show();
    },

    getAutomations() {
      this.$http.get('/automation?ajax=true')
        .then((response) => {
          this.automations = response.data;
        });
    },

    updateStage(stage) {
      for (let i = 0; i < this.pipelines.length; i++) {
        for (let index = 0; index < this.pipelines[i].stages.length; index++) {
          if (this.pipelines[i].stages[index].id == stage.id) {
            this.$set(this.pipelines[i].stages, index, stage);

            return true;
          }
        }
      }

      return null;
    },

    setNewStage(stage) {
      for (let i = 0; i < this.pipelines.length; i++) {
        if (this.pipelines[i].id == stage.pipeline_id) {
          this.$set(this.pipelines[i].stages, this.pipelines[i].stages.length, stage);

          return true;
        }
      }

      return null;
    },

    deleteStage(stage) {
      for (let i = 0; i < this.pipelines.length; i++) {
        const index = this.pipelines[i].stages.indexOf(stage);
        this.pipelines[i].stages.splice(index, 1);
      }

      return null;
    },

    save() {
      this.status.saving = true;

      if (this.status.editing) {
        Http.put(`/stage/${this.createStageForm.stage_id}`, this.createStageForm)
          .then((response) => {
            const stage = response;

            this.updateStage(stage);

            Alert.success(this.__('Estágio editado!'));

            this.closeModal();
          })
          .catch(() => {
            Alert.error(this.__('Erro ao editar estágio'));

            this.closeModal();
          })
          .finally(() => this.status.saving = false);
      } else {
        Http.post('/stage', this.createStageForm)
          .then(() => {
            Alert.success(this.__('Estágio cadastrado'));
          })
          .catch(() => {
            Alert.error(this.__('Erro ao criar estágio'));
          })
          .finally(() => {
            this.status.saving = false;

            this.getPipelines();
            this.closeModal();
          });
      }
    },

    edit(field) {
      this.createStageForm.name = field.name;
      this.createStageForm.pipeline_id = field.pipeline_id;
      this.createStageForm.stage_id = field.id;
      this.createStageForm.automation_id = field.automation_id || null;
      this.status.editing = true;

      this.openModal();
    },

    create(pipelineId) {
      this.status.editing = false;
      this.createStageForm = new BulldeskForm(addStageForm());
      this.createStageForm.pipeline_id = pipelineId;

      this.openModal();
    },

    cancel() {
      this.status.editing = false;

      this.closeModal();
    },

    async destroy(stage) {
      const title = this.__('Deseja remover o estágio');

      if (! await Confirm(`${title} ${stage.name}?`)) {
        return;
      }

      this.$http.delete(`/stage/${stage.id}`)
        .then(() => {
          this.deleteStage(stage);

          Alert.success(this.__('Estágio excluído!'));
        })
        .catch((response) => {
          let message = this.__('Erro ao excluir estágio.');

          console.log(response);

          if (response.data.message != undefined) {
            message = response.data.message;
          }

          Alert.error(message);
        });
    },

    openModal(name = 'custom-stage-modal') {
      this.$refs[name].show();
    },

    closeModal(name = 'custom-stage-modal') {
      this.$refs[name].hide();
    },

    savePipeline() {
      this.pipelineStatus.saving = true;

      if (this.pipelineStatus.editing) {
        Http.put(`/pipeline/${this.createPipelineForm.id}`, this.createPipelineForm)
          .then(() => {
            Alert.success(this.__('Estágio alterado'));
          })
          .catch(() => {
            Alert.error(this.__('Erro ao editar pipeline'));
          })
          .finally(() => {
            this.pipelineStatus.saving = false;

            this.getPipelines();
            this.closeModal('custom-pipeline-modal');
          });
      } else {
        Http.post('/pipeline', this.createPipelineForm)
          .then(() => {
            Alert.success(this.__('Pipeline cadastrado'));

            this.getPipelines();
            this.closeModal('custom-pipeline-modal');
          })
          .catch((response) => {
            if (response.error) {
              return Alert.error(response.error);
            }

            Alert.error(this.__('Erro ao criar pipeline'));
          })
          .finally(() => {
            this.pipelineStatus.saving = false;

            this.closeModal('custom-pipeline-modal');
          });
      }
    },

    cancelPipeline() {
      this.status.editing = false;

      this.closeModal('custom-pipeline-modal');
    },

    startDrag() {
      this.dragging = true;
    },

    endDrag() {
      this.dragging = false;

      this.order();
    },

    order() {
      this.moving = true;

      const pipelines = this.pipelines.map((pipeline) => {
        const stages = pipeline.stages.map((stage) => stage.id);

        return {
          id: pipeline.id,
          stages,
        };
      });

      this.$http.put('/pipeline/order', { pipelines })
        .catch(() => this.getPipelines())
        .finally(() => this.moving = false);
    },

    async destroyPipeline(pipeline) {
      const title = this.__('Deseja remover o pipeline');
      const text = this.__('Isso irá excluir TODOS os negócios existentes no pipeline e não será possível recuperá-los.');

      if (! await Confirm(`${title} ${pipeline.name}? `, text)) {
        return;
      }

      this.$http.delete(`/pipeline/${pipeline.id}`)
        .then(() => {
          Alert.success(this.__('Pipeline removido.'));

          this.getPipelines();
        })
        .catch((response) => {
          let message = this.__('Erro ao remover pipeline.');

          if (response.data.message != undefined) {
            message = response.data.message;
          }

          Alert.error(message);
        });
    },

    editPipeline(field) {
      this.createPipelineForm.id = field.id;
      this.createPipelineForm.name = field.name;
      this.pipelineStatus.editing = true;

      this.openModal('custom-pipeline-modal');
    },
  },
};
</script>

<style scoped>
.btn-cancel {
  font-size: 12px;
  font-weight: 600 !important;
  color: #71767D !important;
}

.btn-cancel:hover {
  color: #5F33FF !important;
}

.break-text {
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}

.purple-title-wrapper {
  background: #E4DDFF;
  border-radius: 24px 24px 0 0;
  overflow: hidden;
  /* padding: 10px; */
  font-family: 'Montserrat';
  font-weight: 600 !important;
  font-size: 16px;
  color: #7C5EE8;
}

.draggable-row {
  position: relative;
  cursor: move;
  /* Indica que a linha é arrastável */
}

.draggable-row:hover {
  background: #F0F0F0;
}

.draggable-icon {
  position: absolute !important;
  left: 16px !important;
  top: 50% !important;
  transform: translateY(-50%);
}

.last-stage {
  /* background: #F0F0F0; */
  border-radius: 0 0 24px 24px;
}

.last-stage td {
  width: 100%;
}

.gray-border-table-wrapper {
  border: solid 1px #D1D1D1;
  border-radius: 24px;
}

.text-transform-none {
  text-transform: none !important;
}

.bg-custom-purple {
  background: #8869FD;
}

.counter-size {
  width: 18px;
  height: 18px;
}

.fs-7 {
  font-size: 14px !important;
}

.mb-4-5 {
  margin-bottom: 32px !important;
}

.select-border:focus,
.select-border.show {
  border-color: #d1d1d1 !important;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25) !important;
  outline: 0 !important;
}

.box-shadow-custom {
  box-shadow: -3px 4px 12px 3px #00000033 !important;
}

.mt-4-5 {
  margin-top: 32px !important;
}

.lh-24 {
  line-height: 24px !important;
}

.lh-21 {
  line-height: 21px !important;
}

.py-2-5 {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}

.pl-4-5 {
  padding-left: 32px !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.radius-8 {
  border-radius: 8px !important;
}

.custom-td-padding {
  padding: 12px 16px 12px 38px !important;
}
</style>
